(function () {
  // Remove page parameter from URL, the page parameter prevents articles from being loaded
  const url = new URL(location.href);
  if (url.searchParams.has("page")) {
    url.searchParams.delete("page");
    location.replace(url.pathname + url.search + url.hash);
    return;
  }

  const PAGE_SIZE = 8;
  const VISIBLE_PAGE_COUNT = 3;
  const DATE_OPTIONS = { month: "short", day: "numeric", year: "numeric" };
  const LOCALE = document.documentElement.lang || navigator.language || "en-US";

  const articlesContainer = document.getElementById("articles-container");
  const paginationControls = document.getElementById("pagination-controls");

  if (!articlesContainer || !paginationControls) return;

  const articlesData = Array.isArray(window.authorArticles) ? window.authorArticles : [];
  const sortedArticles = [...articlesData].sort(
    (a, b) => Number(b.timestamp) - Number(a.timestamp)
  );
  const totalPages = Math.ceil(sortedArticles.length / PAGE_SIZE);

  function formatDate(dateStr) {
    return new Date(dateStr).toLocaleDateString(LOCALE, DATE_OPTIONS);
  }

  function renderArticle(article) {
    const link = document.createElement("a");
    link.href = article.url;
    link.className = "article__card";

    const imageWrap = document.createElement("div");
    imageWrap.className = "article-card__image";
    if (article.image) imageWrap.innerHTML = article.image;

    const textWrap = document.createElement("div");
    textWrap.className = "article-card__text";

    const blog = document.createElement("p");
    blog.className = "article-card__blog";
    blog.textContent = article.blogTitle || "";

    const titleEl = document.createElement("p");
    titleEl.className = "article-card__title";
    titleEl.textContent = article.title || "";

    const dateEl = document.createElement("p");
    dateEl.className = "article-card__date";
    dateEl.textContent = formatDate(article.date);

    textWrap.append(blog, titleEl, dateEl);
    link.append(imageWrap, textWrap);
    return link;
  }

  function getPaginationItems(current) {
    const items = [];
    if (current > VISIBLE_PAGE_COUNT + 1) {
      items.push(1, "ellipsis");
    }
    const start = Math.max(1, current - VISIBLE_PAGE_COUNT);
    const end = Math.min(totalPages, current + VISIBLE_PAGE_COUNT);
    for (let i = start; i <= end; i++) items.push(i);
    if (current < totalPages - VISIBLE_PAGE_COUNT) {
      items.push("ellipsis", totalPages);
    }
    return items;
  }

  function showPage(page) {
    const start = (page - 1) * PAGE_SIZE;
    const pageArticles = sortedArticles.slice(start, start + PAGE_SIZE);

    if (!pageArticles.length) {
      articlesContainer.innerHTML = "";
      const emptyMsg = document.createElement("p");
      emptyMsg.className = "no-articles";
      emptyMsg.setAttribute("role", "status");
      emptyMsg.textContent = "No articles found for this author.";
      articlesContainer.appendChild(emptyMsg);
      return;
    }
    articlesContainer.innerHTML = "";
    const cardsFragment = document.createDocumentFragment();
    pageArticles.forEach((article) => cardsFragment.appendChild(renderArticle(article)));
    articlesContainer.appendChild(cardsFragment);

    if (totalPages <= 0) {
      paginationControls.innerHTML = "";
      return;
    }

    const fragment = document.createDocumentFragment();
    for (const item of getPaginationItems(page)) {
      if (item === "ellipsis") {
        fragment.appendChild(document.createTextNode("..."));
      } else {
        const btn = document.createElement("button");
        btn.type = "button";
        btn.className = "page-number" + (item === page ? " active" : "");
        btn.dataset.page = item;
        btn.textContent = item;
        btn.setAttribute("aria-label", "Go to page " + item);
        if (item === page) {
          btn.setAttribute("aria-current", "page");
        }
        fragment.appendChild(btn);
      }
    }

    paginationControls.innerHTML = "";
    paginationControls.appendChild(fragment);
  }

  paginationControls.addEventListener("click", function (e) {
    const btn = e.target.closest("button[data-page]");
    if (!btn) return;
    showPage(parseInt(btn.dataset.page, 10));
  });

  showPage(1);
})();
